import { createSelector } from 'reselect';

const selectProjects = state => state.projects;
export const selectMyProjects = createSelector([selectProjects], projects => projects || {});
export const selectLoadedState = createSelector(
  [selectProjects],
  projects => !!(projects && projects.loaded)
);
